export const YellowpayIcon = ({
  width,
  height,
  isDark,
}: {
  width: number
  height: number
  isDark: boolean
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 165 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="whitespace-nowrap"
  >
    <path
      d="M49.4199 24V17.5059L44.1172 9.07812H47.8672L51.0117 14.4395L54.166 9.07812H57.9355L52.6133 17.4961L52.6035 24H49.4199Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M59.3223 24V9.08789H68.4238V11.9492H62.5254V15.084H67.7695V17.7305H62.5254V21.1387H68.5215V24H59.3223Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M70.4746 24V9.08789H73.6777V21.1484H78.7852V24H70.4746Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M80.4746 24V9.08789H83.6777V21.1484H88.7852V24H80.4746Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M97.3789 24.3809C92.8477 24.3809 89.2539 20.8945 89.2539 16.5195C89.2539 12.1641 92.8477 8.6875 97.3789 8.6875C101.9 8.6875 105.504 12.1641 105.504 16.5195C105.504 20.8945 101.9 24.3809 97.3789 24.3809ZM97.3789 21.4316C100.113 21.4316 102.301 19.2637 102.301 16.5293C102.301 13.8145 100.113 11.627 97.3789 11.627C94.6348 11.627 92.4473 13.8145 92.4473 16.5293C92.4473 19.2637 94.6348 21.4316 97.3789 21.4316Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M124.205 9.08789H127.623L122.389 24H119.723L116.588 14.4785L116.529 14.4297L116.471 14.4785L113.336 24H110.67L105.436 9.08789H108.941L112.105 19.2148L112.135 19.2441L112.154 19.2148L115.66 9.08789H117.486L120.992 19.2051L121.021 19.2441L121.041 19.2051L124.205 9.08789Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M129.049 24V9.08789H134.029C137.213 9.08789 139.332 10.9238 139.332 13.8242C139.332 16.7051 137.223 18.541 134.078 18.541H132.252V24H129.049ZM132.252 15.8164H133.902C135.416 15.8066 136.266 15.0059 136.266 13.8145C136.266 12.6328 135.416 11.8223 133.893 11.8223H132.252V15.8164Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M149.635 24L148.482 20.9434H142.857L141.705 24H138.287L144.371 9.08789H147.057L153.16 24H149.635ZM143.844 18.3359H147.506L145.68 13.4922L143.844 18.3359Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <path
      d="M156.314 24V17.5059L151.012 9.07812H154.762L157.906 14.4395L161.061 9.07812H164.83L159.508 17.4961L159.498 24H156.314Z"
      fill={isDark ? 'white' : '#0D1117'}
    />
    <rect
      width="22.3829"
      height="22.3829"
      rx="5"
      transform="matrix(0.804185 0.594379 -0.804185 0.594379 18 7.39209)"
      fill="#D7D35F"
    />
    <rect
      width="22.3829"
      height="22.3829"
      rx="5"
      transform="matrix(0.804185 0.594379 -0.804185 0.594379 18 0)"
      fill="#E8E244"
    />
  </svg>
)
